import { memo, useCallback } from 'react'
import { cn } from '@shared/lib/utils'

interface BillingPreset {
  label: string
  interval: string
  period: string
  schedule: string
}

interface BillingPresetsProps {
  interval: string
  period: string
  schedule: string
  onApply: (preset: { interval: string; period: string; schedule: string }) => void
  className?: string
}

const PRESETS: BillingPreset[] = [
  { label: 'Monthly', interval: '1', period: 'month', schedule: 'monthly' },
  { label: 'Quarterly', interval: '3', period: 'month', schedule: 'monthly' },
  { label: 'Annually', interval: '1', period: 'year', schedule: 'yearly' },
]

export const BillingPresets = memo<BillingPresetsProps>(function BillingPresets({
  interval,
  period,
  schedule,
  onApply,
  className,
}) {
  const isActive = useCallback(
    (preset: BillingPreset) =>
      preset.interval === interval &&
      preset.period === period &&
      preset.schedule === schedule,
    [interval, period, schedule]
  )

  return (
    <div className={cn('flex items-center gap-1.5', className)}>
      {PRESETS.map((preset) => {
        const active = isActive(preset)
        return (
          <button
            key={preset.label}
            type="button"
            onClick={() =>
              onApply({
                interval: preset.interval,
                period: preset.period,
                schedule: preset.schedule,
              })
            }
            className={cn(
              'px-3 py-1 rounded-full text-xs font-medium transition-all',
              active
                ? 'bg-foreground text-background shadow-sm'
                : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
            )}
          >
            {preset.label}
          </button>
        )
      })}
    </div>
  )
})

BillingPresets.displayName = 'BillingPresets'
